const setPassword = (playerFormModal, password) => {
    playerFormModal.querySelector('.player-new-password span').innerText =
        password;
    playerFormModal
        .querySelector('.player-new-password')
        .classList.remove('d-none');
    playerFormModal.querySelector('input[name=password]').value = password;
    playerFormModal
        .querySelector('.player-password-deletion-hint')
        .classList.add('d-none');
};

const generatePassword = playerFormModal => {
    const passwordDigits = [];
    while (passwordDigits.length < 3) {
        const digit = Math.floor(Math.random() * 9 + 1);
        if (!passwordDigits.includes(digit)) {
            passwordDigits.push(digit);
        }
    }
    const password = passwordDigits.join(',');

    setPassword(playerFormModal, password);
};

const deletePassword = playerFormModal => {
    playerFormModal.querySelector('input[name=password]').value = '';
    playerFormModal
        .querySelector('.player-password-deletion-hint')
        .classList.remove('d-none');
    playerFormModal
        .querySelector('.player-new-password')
        .classList.add('d-none');
};

const handlePasswordDigitClick = (playerFormModal, passwordDigit) => {
    const emptyDigitInput = Array.from(
        playerFormModal.querySelectorAll('[name="password_digit[]"]')
    ).find(input => !input.value);
    if (!emptyDigitInput) {
        return;
    }
    emptyDigitInput.value = passwordDigit.dataset.passwordDigit;
    if (
        !Array.from(
            playerFormModal.querySelectorAll('[name="password_digit[]"]')
        ).find(input => !input.value)
    ) {
        playerFormModal.querySelector('.save-password-digits').disabled = false;
    }
};

const savePasswordDigits = playerFormModal => {
    const password = Array.from(
        playerFormModal.querySelectorAll('[name="password_digit[]"]')
    )
        .map(input => input.value)
        .join(',');

    setPassword(playerFormModal, password);
};

const resetPasswordDigits = playerFormModal => {
    for (const passwordDigitInput of playerFormModal.querySelectorAll(
        '[name="password_digit[]"]'
    )) {
        passwordDigitInput.value = '';
    }
    playerFormModal.querySelector('.save-password-digits').disabled = true;
};

const playerFormModals = document.querySelectorAll('.player-form-modal');
playerFormModals.forEach(playerFormModal => {
    playerFormModal
        .querySelector('.generate-password')
        .addEventListener('click', () => {
            generatePassword(playerFormModal);
        });

    playerFormModal
        .querySelector('.delete-password')
        .addEventListener('click', () => {
            deletePassword(playerFormModal);
        });

    playerFormModal
        .querySelectorAll('[data-password-digit]')
        .forEach(passwordDigit => {
            passwordDigit.addEventListener('click', () => {
                handlePasswordDigitClick(playerFormModal, passwordDigit);
            });
        });

    playerFormModal
        .querySelector('.save-password-digits')
        .addEventListener('click', () => {
            savePasswordDigits(playerFormModal);
        });

    playerFormModal
        .querySelector('.reset-password-digits')
        .addEventListener('click', () => {
            resetPasswordDigits(playerFormModal);
        });
});
